
<div class="content-container">
    <div class="footer-row">
            <a href="http://www.hhs.gov" target="_blank" rel="noopener noreferrer">U.S. Department of Health &amp; Human Services</a>
    </div>
 
    <div class="footer-row">
 
            <a href="http://www.nih.gov" target="_blank" rel="noopener noreferrer">National Institutes of Health</a>
    </div>
    <div class="footer-row">
        <div class="parent-nf">
            <span class="link"><a href="https://www.hhs.gov/vulnerability-disclosure-policy/index.html" target="_blank" rel="noopener noreferrer">HHS Vulnerability Disclosure</a></span>
            <span class="separator"> | </span>
            <span class="link"><a href="http://www.ncats.nih.gov/">NCATS Home</a></span>
            <span class="separator"> | </span>
            <span class="link"><a href="http://www.nih.gov/about/access.htm" target="_blank" rel="noopener noreferrer">Accessibility</a></span>
            <span class="separator"> | </span>
            <span class="link"><a href="/privacy">Privacy Notice</a></span>
            <span class="separator"> | </span>
            <span class="link"><a href="/licensing">Licensing</a></span>
            <span class="separator"> | </span>
            <span class="link"><a href="http://www.ncats.nih.gov/about/foia.html">FOIA</a></span>
            <span class="separator"> | </span>
            <span class="link"><a href="http://oig.hhs.gov/" target="_blank" rel="noopener noreferrer">OIG</a></span>
        </div>
    </div>
 
    <div class="footer-row">
        <div class="parent-nf">
            <span class="fragment">National Center for Advancing Translational Sciences (NCATS)</span>
            <span class="separator">, </span>
            <span class="fragment">6701 Democracy Boulevard</span>
            <span class="separator">, </span>
            <span class="fragment">Bethesda MD 20892-4874</span>
            <span class="separator"> | </span>
            <span class="fragment">301-435-0888</span>
        </div>
    </div>
</div>